import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { isSerialTicketsMode as isSerialTicketsModeSelector } from '../../../selectors/selectors'
import BookTrip from './BookTrip'
import OrderDetails from './OrderDetails'
import s from './Summary.module.scss'

export default function Summary() {
  const isSerialTicketsMode = useSelector(isSerialTicketsModeSelector)

  return (
    <div className={s.summary}>
      <OrderDetails />
      {isSerialTicketsMode && (
        <>
          <Disclaimer />
          <BookTrip />
        </>
      )}
    </div>
  )
}

function Disclaimer() {
  const { t } = useTranslation()

  return <div className={s.disclaimer}>{t('confirmation.summary.disclaimer')}</div>
}
